import React, { useState, useEffect  } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../store/auth";
import SignupPopup from "./SignupPopup";
import "./LoginPopup.css";
import { createPortal } from "react-dom";

const LoginPopup = ({ handleClose }) => {
  const [showSignup, setShowSignup] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false); 
  
  const navigate = useNavigate();
  const { storeTokenInLS } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  

  async function submit(e) {
    e.preventDefault();

    try {
      const resp = await axios.post(
        "http://localhost:5000/api/login",
        {
          email,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log(resp.data);
      const resp_data = resp.data;
      console.log("data from server", resp_data);
      //stored the token in localhost
      storeTokenInLS(resp_data.token);
      setEmail("");
      setPassword("");
      setLoginSuccess(true);
      alert("Login successful");
      navigate("/");
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    }
  }
  const handleSignupClick = () => {
    setShowSignup(true);
  };

  const closePopups = () => {
    setShowSignup(false);
    handleClose();
  };
// Close the popup if login was successful
useEffect(() => {
  if (loginSuccess) {
    handleClose();
  }
}, [loginSuccess, handleClose]);



  return createPortal (
    <>
    <div className="popup-overlay"></div>
    <div className="popup">
      <div className="popup-inner">
        <button className="close-btn" onClick={handleClose}>Close</button>
        <h2>Login</h2>
        <form onSubmit={submit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">Login</button>
        </form>
        <p>
               Don't have an account?
               <span  onClick={handleSignupClick}>Signup</span>
            </p>
            {showSignup && (
               <SignupPopup handleClose={closePopups} />
            )}
      </div>
    </div>
    </>,
     document.getElementById("popup-root") 
  );
};

export default LoginPopup;